"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
var React = __importStar(require("react"));
var video_context_1 = require("../context/video-context");
var react_1 = require("@xstate/react");
var classnames_1 = __importDefault(require("classnames"));
var selectors_1 = require("../selectors");
var LoadingSpinner = function (_a) {
    var className = _a.className;
    var videoService = (0, video_context_1.useVideo)();
    var error = (0, react_1.useSelector)(videoService, selectors_1.selectHasFailed);
    if (error) {
        return null;
    }
    return React.createElement("div", { className: (0, classnames_1.default)('cueplayer-react-loading-spinner', className) });
};
exports.LoadingSpinner = LoadingSpinner;
